import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/admin/billing')({
  beforeLoad: async ({ context }) => {
    const auth = (context as any).auth
    if (auth && !auth.userId) {
      throw new Error('Authentication required')
    }
  },
})
